import { graphql } from '@/gql/codegen/gql';
import { useMutation } from '@apollo/client';
import { useCallback, useState } from 'react';

export const LOGOUT_MUTATION = graphql(/* GraphQL */ `
  mutation EmbaLogout {
    embaLogout {
      logout
      logoutUrl
    }
  }
`);

export const useLogout = () => {
  const [isProcessingLogout, setIsProcessingLogout] = useState(false);

  const [
    logoutMutation,
    { error: logoutMutationError, loading: logoutMutationLoading },
  ] = useMutation(LOGOUT_MUTATION, {});

  const onLogout = useCallback(async () => {
    // ログアウト処理成功時にリダイレクトするのでisProcessingLogoutをfalseに戻す必要は無し
    setIsProcessingLogout(true);
    await logoutMutation({
      onCompleted: (data) => {
        if (data.embaLogout.logout) {
          window.location.href = data.embaLogout.logoutUrl;
        }
      },
    });
  }, [logoutMutation]);

  return {
    onLogout,
    isProcessingLogout,
    logoutMutationError,
    logoutMutationLoading,
  };
};
